<template>
  <div class="profitRecord">
    <div class="top" style="border-bottom: 1px solid #dcdfe6">
      <div class="time-filter" style="display: flex; align-items: center; flex-wrap: wrap">
        <span class="label">统计时间</span>
        <el-button
          type="text"
          :class="timeType === 'DAY' ? 'active' : ''"
          @click="chooseType('DAY')"
        >今日</el-button>
        <el-button
          type="text"
          :class="timeType === 'MONTH' ? 'active' : ''"
          @click="chooseType('MONTH')"
        >本月</el-button>
        <el-button
          type="text"
          :class="timeType === 'YEAR' ? 'active' : ''"
          @click="chooseType('YEAR')"
        >本年</el-button>
        <el-button
          type="text"
          :class="timeType === 'ALL' ? 'active' : ''"
          @click="chooseType('ALL')"
        >全部</el-button>
        <span class="label">自定义</span>
        <el-date-picker
          v-model="form.date1"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="开始日期"
          size="small"
          style="width: 140px"
        />
        <span style="margin: 0 6px">至</span>
        <el-date-picker
          v-model="form.date2"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="结束日期"
          size="small"
          style="width: 140px"
        />
        <el-form :inline="true" :model="formInline" size="medium" style="margin-left: 20px">
          <el-form-item label="充电单号">
            <el-input v-model="formInline.startChargeSeq" placeholder="请输入充电单号" style="width: 160px" />
          </el-form-item>
          <el-form-item label="充电枪编码">
            <el-input v-model="formInline.connectorID" placeholder="请输入充电枪编码" style="width: 160px" />
          </el-form-item>
          <el-form-item label="是否结算">
            <el-select v-model="formInline.settled" placeholder="请选择" clearable style="width: 110px">
              <el-option label="未结算" :value="0" />
              <el-option label="已结算" :value="1" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content" style="position: relative">
      <el-button type="primary" style="margin-top: 20px" @click="exportOrder">导出</el-button>
      <el-button type="warning" style="margin-top: 20px" :disabled="multipleSelection.length === 0" @click="settleOrders">批量结算</el-button>
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%; margin-top: 20px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center" width="50" />
        <el-table-column type="index" align="center" width="50" label="序号" />
        <el-table-column label="充电单号" align="center" min-width="140">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="gotoDetail(scope.row)">{{ scope.row.startChargeSeq }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="电站名称" align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.stationName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充电枪编码" align="center" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.connectorID }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户归属企业" align="center" min-width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.accountOrgName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.payTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充电度数" align="center" width="90">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.power) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收电费" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.elecMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收服务费" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ getFixed2(scope.row.serviceMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否结算" align="center" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.settled === 1 ? 'success' : 'info'">
              {{ scope.row.settled === 1 ? '已结算' : '未结算' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="运营商分润" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ getFloat(scope.row.operatorProfit) }}</span>
          </template>
        </el-table-column>
        <template v-if="tableProfit && tableProfit.length > 0">
          <el-table-column
            v-for="(item, index) in tableProfit"
            :key="index"
            :label="item.targetName"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[item.targetId] || scope.row[item.targetId] === 0">{{ getFloat(scope.row[item.targetId]) }}</span>
              <span v-else> -- </span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      v-if="pageshow"
      style="margin-top: 20px"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  name: 'ProfitRecord',
  data() {
    return {
      timeType: 'DAY',
      form: {
        date1: '',
        date2: ''
      },
      formInline: {
        startChargeSeq: '',
        connectorID: '',
        settled: ''
      },
      tableProfit: [],
      tableData: [],
      multipleSelection: [],
      pageshow: true,
      currentPage: 1,
      total: 0,
      pagesize: 10
    }
  },
  mounted() {
    this.getProfitData()
    this.getPageData()
  },
  methods: {
    chooseType(val) {
      this.timeType = val
      this.form.date1 = ''
      this.form.date2 = ''
    },
    reset() {
      this.timeType = 'DAY'
      this.form.date1 = ''
      this.form.date2 = ''
      this.formInline.startChargeSeq = ''
      this.formInline.connectorID = ''
      this.formInline.settled = ''
      this.currentPage = 1
      this.onSubmit()
    },
    onSubmit() {
      this.getProfitData()
      this.getPageData()
    },
    handleSizeChange(val) {
      this.pageshow = false
      this.pagesize = val
      this.tableData = []
      this.getPageData()
    },
    handleCurrentChange(val) {
      this.pageshow = false
      this.currentPage = val
      this.tableData = []
      this.getPageData()
    },
    getProfitData() {
      const data = {
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2,
        startChargeSeq: this.formInline.startChargeSeq,
        connectorID: this.formInline.connectorID,
        settled: this.formInline.settled
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/detail/order/targets',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp && resp.length > 0) {
            this.tableProfit = resp
          } else {
            this.tableProfit = []
          }
        }
      })
    },
    getPageData() {
      const data = {
        pageNo: this.currentPage,
        pageSize: this.pagesize,
        timeType: this.timeType,
        startTime: this.form.date1,
        endTime: this.form.date2,
        startChargeSeq: this.formInline.startChargeSeq,
        connectorID: this.formInline.connectorID,
        settled: this.formInline.settled
      }
      this.$store.dispatch('form/handle', {
        url: '/finance/profit/detail/order/page',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.tableData = resp.list
            this.pageshow = true
          } else {
            this.pageshow = false
            this.tableData = []
          }
          this.currentPage = resp.pageNo
          this.total = resp.count
          this.pagesize = resp.pageSize
        }
      })
    },
    exportOrder() {
      const url = HOST + '/finance/profit/detail/order/export'
      $.fileDownload(url, {
        httpMethod: 'get',
        data: {
          pageNo: this.currentPage,
          pageSize: this.pagesize,
          timeType: this.timeType,
          startTime: this.form.date1,
          endTime: this.form.date2,
          startChargeSeq: this.formInline.startChargeSeq,
          connectorID: this.formInline.connectorID,
          settled: this.formInline.settled,
          token: window.localStorage.getItem('token')
        },
        failCallback: () => {
          this.$notify({
            title: '失败',
            message: '导出失败',
            type: 'error'
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    settleOrders() {
      if (this.multipleSelection.length === 0) {
        this.$notify({
          title: '提示',
          message: '请先勾选要结算的订单',
          type: 'warning'
        })
        return
      }
      const orderIds = this.multipleSelection.map(item => item.orderId)
      this.$confirm('确定要将选中的 ' + orderIds.length + ' 笔订单标记为已结算吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('form/handle', {
          url: '/finance/profit/settle',
          data: orderIds,
          method: 'post',
          callback: () => {
            this.$notify({
              title: '成功',
              message: '结算成功',
              type: 'success'
            })
            this.getProfitData()
            this.getPageData()
          }
        })
      }).catch(() => {})
    },
    gotoDetail(item) {
      this.$router.push({
        path: '/orderManagement/historyDetail',
        query: { data: item.orderId, num: item.startChargeSeq }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.profitRecord {
  .time-filter {
    .label {
      margin-right: 10px;
      font-size: 14px;
      color: #333;
    }
    .active {
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .el-button--text {
      width: 70px;
    }
    .el-form {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-bottom: 0;
        margin-right: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ticketManagement/profitRecord.vue